import React from 'react';
import { Link } from '@mui/material';
import { Typography } from 'src/components/new/Typography';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

interface ContactInformationProps {
  submitterFirstName?: string | null;
  submitterLastName?: string | null;
  submitterEmail?: string | null;
  organizationPhone?: string | null;
  organizationCountryCode?: string | null;
}

const EM_DASH = '\u2014';

const ContactInformation = ({
  submitterFirstName,
  submitterLastName,
  submitterEmail,
  organizationPhone,
  organizationCountryCode,
}: ContactInformationProps) => {
  const submittedBy =
    submitterFirstName || submitterLastName
      ? `${submitterFirstName ?? ''} ${submitterLastName ?? ''}`.trim()
      : EM_DASH;

  // Rendered as a mailto link so staff can start an email from the side screen.
  // Falls back to an em dash for jobs submitted before the snapshot existed.
  const email = submitterEmail ? (
    <Link href={`mailto:${submitterEmail}`} color="#436eb2">
      {submitterEmail}
    </Link>
  ) : (
    EM_DASH
  );

  let phone: string = EM_DASH;
  if (organizationPhone) {
    const parsed = parsePhoneNumberFromString(
      organizationPhone,
      (organizationCountryCode as CountryCode) || 'US',
    );
    phone = parsed ? parsed.formatInternational() : organizationPhone;
  }

  const items: { label: string; value: React.ReactNode }[] = [
    { label: 'Submitted by', value: submittedBy },
    { label: 'Submitter email', value: email },
    { label: 'Organization phone', value: phone },
  ];

  return (
    <>
      <Typography
        sx={{
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
          fontWeight: '600',
        }}
      >
        Contact Information
      </Typography>
      <div
        style={{
          padding: '0.9375rem',
          border: '0.0625rem solid #cac4d0',
          borderRadius: '0rem',
        }}
      >
        {items.map((item) => (
          <Typography key={item.label} sx={{ marginBottom: '0.75rem' }}>
            <span style={{ fontWeight: '500' }}>{item.label}: </span>
            {item.value}
          </Typography>
        ))}
      </div>
    </>
  );
};

export default ContactInformation;
